<div class="row">
  <div class="col-sm-12">
    <h3 class="sub-title alert alert-info">permissions for {{roleGroup['name']}}</h3></div>
  <div class="col-sm-12 text-end alert">
      <a [routerLink]="['/admin/role/new',0]" class ="btn btn-primary"> <i class="fa fa-plus"></i> Add New role</a>
  </div>
</div>
<div class="table-responsive" *ngIf="permissions.length>0">
<span [appMath]="''"></span>
<table  datatable [dtOptions]="dtOptions" class="table table-striped display compact">
  <thead>
  <tr>
    <th>Id</th>
    <th>Name</th>
    <th>count</th>
    <th>RoleGroup</th>
  </tr>
  </thead>

  <tbody>

  <tr *ngFor="let role of permissions;">
      <td>{{role['id']}}</td>
     <td>
      {{role['text']}}
      </td>
      <td>{{role['isOk']}}</td>
      <td>
        <button *ngIf="!role['isOk']"  (click)="addPermissionToRoleGroup(role.id)" class="btn btn-primary">Add Permission</button>
        <button *ngIf="role['isOk']" (click)="removePermissionToRoleGroup(role.id)" class="btn btn-danger">Remove Permission</button>

      </td>
  </tr>

  </tbody>

</table>

</div>

<app-spinner *ngIf="(permissions.length==0) && loading"></app-spinner>
<div *ngIf="(permissions.length==0) && !loading" class="text-center">No Records Found </div>

<hr/>
<div class="text-center" >
  <a [routerLink]="['/admin/permission/new']">Add New  role</a>
</div>





